var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legends"},[_c('div',{staticClass:"legend legend-direct"},[_vm._v("Étape directe")]),_c('div',{staticClass:"legend legend-indirect"},[_vm._v("Étape "+_vm._s(_vm.term))]),(_vm.isAdmin && _vm.show)?_c('div',{staticClass:"legend legend-completude"},[_vm._v(" Étape pour complétude ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }